export default __webpack_public_path__ + "static/media/arrows_clockwise_white.1719eea6.svg";